import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const MobileNavCtx = createContext({ open: false, openNav: () => {}, closeNav: () => {} });

export function MobileNavProvider({ children }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Auto-close drawer on route change
  useEffect(() => { setOpen(false); }, [location.pathname]);

  // Lock body scroll while drawer is open
  useEffect(() => {
    if (open) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => { document.body.style.overflow = prev; };
    }
  }, [open]);

  const openNav = useCallback(() => setOpen(true), []);
  const closeNav = useCallback(() => setOpen(false), []);
  return (
    <MobileNavCtx.Provider value={{ open, openNav, closeNav }}>
      {children}
    </MobileNavCtx.Provider>
  );
}

export function useMobileNav() {
  return useContext(MobileNavCtx);
}
